export default function reducer(state = {
  sucursalesHN: undefined,
  lastFetched: undefined
}, action) {
  switch (action.type) {
    case "LOAD_SUCURSALES_HN": {
      state = { ...state, ...action.payload }
      break
    }
    default: {

    }
  }
  return state
}